"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextHint = void 0;
const getHints_js_1 = require("./getHints.js");
/**
 *
 * @param {import('openchemlib').Molecule} correct
 * @param {import('openchemlib').Molecule} proposed
 * @param {Array} providedHints
 */
function getNextHint(correct, proposed, providedHints) {
    const hints = (0, getHints_js_1.getHints)(correct, proposed);
    const possibleHints = hints.filter((possibleHint) => !providedHints.some((providedHint) => possibleHint.hash === providedHint.hash));
    if (possibleHints.length === 0)
        return undefined;
    return {
        ...possibleHints[0],
        idCode: proposed.getIDCode(),
    };
}
exports.getNextHint = getNextHint;
//# sourceMappingURL=getNextHint.js.map